import { Component, Input, HostBinding, OnChanges, SimpleChange, HostListener, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
declare var $ :any;

@Component({
  selector: 'suppress-block',
  templateUrl: './suppress-block.component.html',
  styleUrls: ['./suppress-block.component.scss']
})
export class SuppressBlockComponent implements OnChanges, AfterViewInit {

  @Input() updateSize: any = 1;
  @Input() apply: boolean = true;
  @Input() oneAction: boolean = false;
  @Input() active: boolean = false;
  @Input() expandOnClick: boolean = true;
  @Input() class: string = '';
  @Input() height: number = 160;
  
  @HostBinding('className') className = this.class;

  @ViewChild('content', {static:true}) elementView: ElementRef;
  
  constructor() {
  }

  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    if(changes?.active || changes?.apply)
      this.updateClassName();

    if(changes?.updateSize)
      this.updateHeightSize();
  }

  updateClassName(){
    this.className = [this.class, this.apply? 'apply' : '', this.active? 'active' : ''].join(' ');
  }

  toggle(event){
    event.stopPropagation();
    this.active = !this.active;

    if(this.oneAction)
      this.apply = false;

    this.updateClassName();
  }

  ngAfterViewInit() {
    this.updateHeightSize();
  }

  updateHeightSize(){
    if(this.updateSize > 0)
     setTimeout(() => { this.apply = this.elementView.nativeElement.offsetHeight > this.height; this.updateClassName(); },0);
    else 
      this.updateClassName();
  }

}
